export default __webpack_public_path__ + "static/media/linda-bw.58ccec0f.jpeg";